import {ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges} from "@angular/core";
import * as _ from "lodash";

@Component({
  standalone: false,
  selector: 'app-service-package-weight',
  templateUrl: './service-package-weight.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ServicePackageWeightComponent implements OnInit, OnChanges {
  @Input() items: any;

  public totalWeight: any;

  ngOnInit() {
    this.initTotalWeight();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.items && !changes.items.isFirstChange()) {
      this.initTotalWeight();
    }
  }

  private initTotalWeight() {
    this.totalWeight = this.items.reduce((acc, i) => {
      return acc + _.get(i, 'weight', 0)
    }, 0);
  }
}
